module.exports = __webpack_public_path__ + "static/media/infiniti-off-app-provider-icon.3604d688.svg";